'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _history = require('history');

var history = (0, _history.createBrowserHistory)();

exports.default = history;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/history.js
// module id = 128
// module chunks = 177